<nav mat-tab-nav-bar *ngIf="links" class="tab-menu">
  <ng-container *ngFor="let link of links">
    <a
      mat-tab-link
      *ngIf="link.visibility == null ? true : link.visibility"
      [routerLink]="link.path"
      routerLinkActive="active"
      #RouterLinkActive="routerLinkActive"
      [active]="RouterLinkActive.isActive"
    >
      {{ link.title }}
      <span *ngIf="(link.counter$ | async) != null" class="counter">
        {{ link.counter$ | async }}
      </span>
    </a>
  </ng-container>
</nav>

<ng-content></ng-content>
